// extracted by mini-css-extract-plugin
module.exports = {"container":"PBxeM-J8QM06uuJN-j71-"};